import { createAsyncThunk } from '@reduxjs/toolkit';

import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { AggregatorHttpGetService } from '../../Services/AggregatorHttpConfig';
import { IGetAddressWithPostCodeQuery } from '../../Types/Queries/IGetAddressWithPostCodeQuery';

export const getAddressWithPostCodeThunk = createAsyncThunk(
  'Aggregator/getAddressWithPostCode',
  async (query: IGetAddressWithPostCodeQuery) => {
    return await AggregatorHttpGetService({
      url: `${_apiPathManagerConfig?.Aggregator.PostCode.GetAddressWithPostCode}`,
      params: query,
    });
  }
);
